exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../../../css-loader/dist/cjs.js??ref--8-1!../../styles/mixins/icon.css"), "");
// Module
exports.push([module.id, "._1kKByN_PUbaMG8Bv40VHeZ{display:-webkit-box;display:-ms-flexbox;display:flex;& button{@mixin iconCommon;height:20px;-ms-flex-item-align:center;align-self:center}& svg{height:15px;width:20px}}html[dir] ._1kKByN_PUbaMG8Bv40VHeZ{margin:0 8px}", ""]);
// Exports
exports.locals = {
	"n-networkIndicator": "_1kKByN_PUbaMG8Bv40VHeZ"
};